<template>
<div>
    <header class="site-header desktop">
        <div class="wrapper site-header__wrapper">
            <div class="site-header__start">
                <router-link class="brand" to="/">
                    <img class="logo-img" src="../../assets/images/culture-logo.png" alt="" />
                </router-link>
            </div>
            <div class="site-header__middle">
                <nav class="nav">
                    <button class="nav__toggle" aria-expanded="false" type="button">
                        menu
                    </button>
                    <ul class="nav__wrapper">
                        <li class="nav__item">
                            <router-link to="/dashboard">Dashboard</router-link>
                        </li>
                        <li class="nav__item">
                            <a target="_blank" href="https://stores.culturesquare.com">Store</a>
                        </li>
                        <li class="nav__item">
                            <router-link to="/listings/events/create">Host Event</router-link>
                        </li>
                        <li class="nav__item">
                            <router-link to="/listings/events">Attend Event</router-link>
                        </li>
                        <li class="nav__item">
                            <router-link to="/faqs">FAQ </router-link>
                        </li>
                        <li class="nav__item">
                            <router-link to="/contact-us">Contact Us</router-link>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="site-header__end">
                <span v-if="notifications.length>0" @click="handleNotifiyDropDown" class="text-white position-relative mr-2">
                    <b-icon icon="bell" font-scale="1.3"></b-icon>
                    <span class="notification-circle">{{notifications.length}}</span>
                    <ul v-if="showNotifyDropdown" class="notify-dropdown" v-click-outside="hideNotifyDropdown">
                        <li v-for="(notify, index) in notifications" :key="index">
                            <a :href="notify.url" class="font12 text-black">
                                <b-icon icon="check" font-scale="1"></b-icon>
                                <span class="font10 text-black">{{notify.message | truncate(40)}}</span>
                            </a>
                        </li>
                        <li>
                            <router-link class="font10 culture-primary" to="/notifications">view all </router-link>
                        </li>
                    </ul>
                </span>
                <router-link class="profile-icon" to="#" v-if="!isLoggedIn">
                    <font-awesome-icon @click="handleDropDown" class="fa-2x" :icon="['fas', 'user-circle']" />
                    <ul v-if="showDropdown" class="dropdown" v-click-outside="hideDropdown">
                        <li>
                            <router-link to="/accounts/signup"> Sign Up</router-link>
                        </li>
                        <li>
                            <router-link to="/accounts/signin">Sign In </router-link>
                        </li>
                    </ul>
                </router-link>
                <span class="profile-icon" v-if="isLoggedIn">
                    <img class="img-profile" @click="handleDropDown" :src="getAvatar" alt="">

                    <ul v-if="showDropdown" class="dropdown" v-click-outside="hideDropdown">

                        <li>
                            <router-link to="/profile">
                                <b-icon icon="person" font-scale="0.9"></b-icon> My Profile
                            </router-link>
                        </li>

                        <li>
                            <router-link to="/languages/events/created">
                                <b-icon icon="book" font-scale="0.9"></b-icon>
                                My Courses
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/languages/clubs/created">
                                <b-icon icon="house-door" font-scale="0.9"></b-icon> My Clubs
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/listings/created">
                                <b-icon icon="calendar-event" font-scale="0.9"></b-icon> My Events
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/recipes/created">
                                <b-icon icon="card-text" font-scale="0.9"></b-icon> My Recipes
                            </router-link>
                        </li>

                        <li>
                            <a href="#" @click="logout">Logout </a>
                        </li>
                    </ul>
                </span>

            </div>
        </div>
    </header>
    <header class="site-header mobile">
        <div class="wrapper site-header__wrapper">
            <div class="site-header__start">
                <b-icon @click="openMenu" icon="list" scale="1.5" class="text-white"></b-icon>
            </div>
            <div class="site-header__middle">
                <router-link class="brand" to="/">
                    <img class="logo-img"  src="../../assets/images/culture-logo.png" alt="" />
                </router-link>

            </div>
            <div class="site-header__end">
                <span v-if="notifications.length>0" @click="handleNotifiyDropDown" class="text-white  position-relative mr-2">
                    <b-icon icon="bell" font-scale="1.3"></b-icon>
                    <span class="notification-circle">{{notifications.length}}</span>
                    <ul v-if="showNotifyDropdown" class="notify-dropdown" v-click-outside="hideNotifyDropdown">
                        <li v-for="(notify, index) in notifications" :key="index">
                            <a :href="notify.url" class="font12 text-black">
                                <b-icon icon="check" font-scale="1"></b-icon>
                                <span class="font10 text-black">{{notify.message | truncate(40)}}</span>
                            </a>
                        </li>
                        <li>
                            <router-link class="font10 culture-primary" to="/notifications">view all </router-link>
                        </li>
                    </ul>
                </span>

                <router-link class="profile-icon" to="#" v-if="!isLoggedIn">
                    <font-awesome-icon @click="handlemobileDropDown" class="fa-2x" :icon="['fas', 'user-circle']" />
                    <ul v-if="showmobileDropdown" class="dropdown">
                        <li>
                            <router-link to="/accounts/signup"> Sign Up</router-link>
                        </li>
                        <li>
                            <router-link to="/accounts/signin">Sign In </router-link>
                        </li>
                    </ul>
                </router-link>
                <span class="profile-icon" v-if="isLoggedIn">
                    <img class="img-profile" @click="handlemobileDropDown" :src="getAvatar" alt="">

                    <ul v-if="showmobileDropdown" class="dropdown">

                        <li>
                            <router-link to="/profile">
                                <b-icon icon="person" font-scale="0.9"></b-icon> My Profile
                            </router-link>
                        </li>

                        <li>
                            <router-link to="/languages/events/created">
                                <b-icon icon="book" font-scale="0.9"></b-icon>
                                My Courses
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/languages/clubs/created">
                                <b-icon icon="house-door" font-scale="0.9"></b-icon> My Clubs
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/listings/created">
                                <b-icon icon="calendar-event" font-scale="0.9"></b-icon> My Events
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/recipes/created">
                                <b-icon icon="card-text" font-scale="0.9"></b-icon> My Recipes
                            </router-link>
                        </li>

                        <li>
                            <a href="#" @click="logout">Logout </a>
                        </li>
                    </ul>
                </span>

            </div>
        </div>
        <div class="slideout" id="slideout">
            <ul class="">
                <li class="nav__item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="nav__item">
                    <a target="_blank" href="https://stores.culturesquare.com">Store</a>
                </li>
                <li class="nav__item">
                    <router-link to="/listings/events/create">Host Event</router-link>
                </li>
                <li class="nav__item">
                    <router-link to="/listings/events">Attend Event</router-link>
                </li>
                <li class="nav__item">
                    <router-link to="/faqs">FAQ </router-link>
                </li>
                <li class="nav__item">
                    <router-link to="/contact-us">Contact Us</router-link>
                </li>
            </ul>
        </div>
    </header>
</div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import 'reset-css'
export default {
    name: "Header",
    directives: {
        clickOutside: vClickOutside.directive
    },
    data: function () {
        return {
            showDropdown: false,
            showNotifyDropdown: false,
            showmobileDropdown: false,
            loggedIn: true,
            notifications: [],
            defaultImage: require('../../assets/images/prof-img.png')
        }
    },
    mounted() {
        this.get_notifications();
    },
    computed: {
        currentUser: function () {
            return this.$store.getters.currentUser;
        },
        isLoggedIn: function () {
            return this.$store.getters.isLoggedIn;
        },
        getAvatar: function () {
            return (this.$store.getters.userprofile.photo_thumb) ? this.$store.getters.userprofile.photo_thumb : this.defaultImage
        },
    },
    methods: {
        handleNotifiyDropDown() {
            if (this.notifications.length > 0) {
                this.showNotifyDropdown = !this.showNotifyDropdown
            }
        },
        handleDropDown() {
            this.showDropdown = !this.showDropdown
        },
        handlemobileDropDown() {
            this.showmobileDropdown = !this.showmobileDropdown
        },
        hideDropdown() {
            this.showDropdown = false
        },
        hideNotifyDropdown() {
            this.showNotifyDropdown = false
        },
        openMenu() {
            var slide = document.getElementById('slideout')
            if (slide.style.marginLeft === '0px') {
                slide.style.marginLeft = '-150px'
            } else {
                slide.style.marginLeft = '0'
            }
        },
        async get_notifications() {
            if (this.isLoggedIn) {
                await this.$store.dispatch("getNotifications")
                this.notifications = await this.$store.getters.notifications.slice(0, 5);
            }
        },
        logout: function () {
            this.$store.dispatch("logout").then(() => {
                this.$router.push("/accounts/signin");
            });
        },
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
@import "./styles.scss";
@import "./header.scss";
</style>
